import queries from '../utils/queries';
import statuses from '../utils/statuses';

export default {

  beforeCreate() {
    this.queries = queries;
    this.statuses = statuses;
  },

};



// WEBPACK FOOTER //
// ./src/components/MPayHelpersMixin.js